import * as React from 'react';

interface Props {
    stroke?: string;
}

const SvgScrollDownLarge: React.FC<Props> = (
    props: React.SVGProps<SVGSVGElement>
) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.63 20.31">
            <path
                fill="none"
                stroke={props.stroke || '#505251'}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M37.63 1L19.31 19.31 1 1"
                data-name="Layer 2"
            />
        </svg>
    );
};

export default SvgScrollDownLarge;
